export const GAME_CREATION_MODAL_ID = 'game-creation-modal-id';
